import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { HiExternalLink } from 'react-icons/hi'
import { BsServer } from 'react-icons/bs'
import { GoMarkGithub } from 'react-icons/go'

function ProjectDetails() {
 const { id } = useParams();
 const [project, setProject] = useState({});
 const getProject = async () => {
     try{
         const { data } = await axios.get(`https://hr-meheraj-portfolio.herokuapp.com/projects/${id}`);
         setProject(data);
     }catch(err){
         console.log(err.message);
     }
 }
 useEffect(() => {
     getProject();
 },[id])
 if(!project){
     return <img className='absolute top-[70px] left-[70px] right-[70px] bottom-[70px] w-full ' src={'https://flevix.com/wp-content/uploads/2021/06/Electric-Loading.gif'} alt={"Loading"}/>
 }
  return (
    <div className='text-white max-w-[720px] mx-auto mt-[20px] mb-[70px]'>
        <img src={project?.imgURL} alt={project?.title} className='w-full rounded-md'/>
        <br/>
        <h2 className='text-xl sm:text-2xl md:text-4xl font-bold text-[#04a2c6d6]'>{project?.title}</h2>
        <br/>
        <div className="flex gap-[15px] flex-wrap">
              {
                  project?.categories?.map((category, index) => <span className='bg-[#ffff00] text-black py-[2px] px-[10px] rounded-md shadow-md' key={index}>{category}</span>)
              }
        </div>
        <br/>
        <br/>
        <h3 className='text-[18px] font-semibold md:text-xl mb-3 details'>Project Details : </h3>
        <ul className='list-disc ml-[25px] mb-[30px]'>
            {
                project?.details?.map((detail, index) => <li className='mb-[10px] text-[#8f8fb5]' key={index}>{detail}</li>)
            }
        </ul>
        <div className="flex gap-[15px]">
            {project?.liveLink &&  (<a href={project?.liveLink} target={"_blank"} className='project-link flex items-center flex-col gap-y-[10px]'> <HiExternalLink className='text-[29px]'/> <a >Live Site</a>  </a>)}
            {project?.clientSideRepoLink &&<a  href={project?.clientSideRepoLink} target={"_blank"} className='project-link flex items-center flex-col gap-y-[10px]'><GoMarkGithub className='text-[29px]'/> <a>Client Site</a> </a>}
            {project?.serverSideRepoLink && <a  href={project?.serverSideRepoLink} target={"_blank"} className='project-link flex items-center flex-col gap-y-[10px]'><BsServer className='text-[29px]'/><a> Server Site</a> </a>}
        </div>
        
    </div>
  )
}

export default ProjectDetails